import { createSlice } from "@reduxjs/toolkit";
import { AppThunk, AppDispatch } from "./store";
import { ServiceLocater, Services } from "../service-locater";
import { UserRepository, Loading } from "../domain";

const phoneNumberRegex = /^[0-9\b]+$/;

type LoginRegisterState = {
  phoneNumber: string;
  isRegistered?: boolean;
  loading: Loading;
};

const initialState: LoginRegisterState = {
  phoneNumber: "",
  loading: "idle",
};

const loginRegisterSlice = createSlice({
  name: "loginRegister",
  initialState: initialState,
  reducers: {
    setPhoneNumber(state, action) {
      const { payload } = action;
      if (payload === "" || phoneNumberRegex.test(payload)) {
        state.phoneNumber = payload;
      }
    },
    checkIsRegisteredLoading(state) {
      state.loading = "pending";
    },
    checkIsRegisteredSuccess(state, action) {
      state.loading = "succeeded";
      state.isRegistered = action.payload;
    },
    checkIsRegisteredFailure(state) {
      state.loading = "failed";
    },
    editPhoneNumber(state) {
      state.loading = "idle";
      state.isRegistered = undefined;
    },
  },
});

export const { setPhoneNumber, editPhoneNumber } = loginRegisterSlice.actions;
export default loginRegisterSlice.reducer;

const {
  checkIsRegisteredLoading,
  checkIsRegisteredSuccess,
  checkIsRegisteredFailure,
} = loginRegisterSlice.actions;

export const checkIsRegistered = (): AppThunk => async (
  dispatch: AppDispatch,
  getState
) => {
  dispatch(checkIsRegisteredLoading());
  const res = await ServiceLocater.get<UserRepository>(
    Services.UserRepository
  ).isRegistered(getState().loginRegister.phoneNumber);
  await res.fold<Promise<void>>(
    async (_) => {
      dispatch(checkIsRegisteredFailure());
    },
    async (isRegistered) => {
      if (isRegistered === false) {
        const res = await ServiceLocater.get<UserRepository>(
          Services.UserRepository
        ).numberRegister(getState().loginRegister.phoneNumber);
        res.fold(
          (_) => dispatch(checkIsRegisteredFailure()),
          (_) => dispatch(checkIsRegisteredSuccess(isRegistered))
        );
      } else {
        dispatch(checkIsRegisteredSuccess(isRegistered));
      }
    }
  );
};
